export default "__VITE_ASSET__bw7o9zlw__"